export default __webpack_public_path__ + "static/media/prick-1.541befb5.jpg";